<template>
  <div class="container_self">
    <el-row class="table_parent">
      <h3>视频列表</h3>

      <el-form
        size="mini"
        label-width="120px"
        @submit.native.prevent
        :model="videoSearch"
        :inline="true"
        class="search_parent"
      >
        <el-form-item label="视频名称">
          <el-input
            type="text"
            v-model="videoSearch.videoName"
            placeholder="请输入视频名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="视频类型">
          <el-select v-model="videoSearch.videoType" clearable placeholder="请选择">
            <el-option
              v-for="(item, index) in categoryList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否推荐">
          <el-select v-model="videoSearch.recommend" clearable placeholder="请选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="danger" size="mini" @click="searchList">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="videoList" v-loading="loading">
        <el-table-column
          label="视频名称"
          prop="videoName"
          align="center"
        ></el-table-column>
        <el-table-column label="视频类型" align="center" width="80">
          <template slot-scope="scope">
            <span>{{
              categoryList.find((item) => item.id == scope.row.videoType).name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="视频图片" width="200px" align="center">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.videoImage"
              alt=""
              :preview-src-list="[scope.row.videoImage]"
              fit="cover"
              style="width: 100px"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="视频缩略图" width="200px" align="center">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.videoImageThumb"
              alt=""
              :preview-src-list="[scope.row.videoImageThumb]"
              fit="cover"
              style="width: 100px"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="是否上线" width="100px" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.online">是</span>
              <span v-else>否</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="视频链接" align="center">
          <template slot-scope="scope">
            <span @click="playVideo(scope.row.name, scope.row.url)">{{
              scope.row.url
            }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="checkVideo(scope.row.id)"
              >查看</el-button
            >
            <el-button size="mini" type="success" @click="checkVideo(scope.row.id)"
              >更新</el-button
            >
            <el-button size="mini" type="danger" @click="deleteVideo(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="videoSearch.currentPage"
        :page-size="videoSearch.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :page-sizes="[30, 50, 100, 200]"
      ></el-pagination>
    </el-row>

    <el-dialog
      :title="videoName"
      :visible.sync="dialogFormVisible"
      :before-close="handleClose"
    >
      <video
        :src="videoUrl"
        controls
        preload="metadata"
        autoplay
        style="width: 100%"
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      dialogFormVisible: false,
      videoUrl: "",
      videoName: "",
      videoSearch: {
        currentPage: 1,
        pageSize: 30,
        recommend: "",
        videoName: "",
        videoType: "",
      },
      categoryList: [],
      videoList: [],
      total: 0,
      loading: false,
    };
  },
  methods: {
    async getCategoryList() {
      await axiosGet("/api/video/classify/list").then((res) => {
        if (res.code == 0) {
          this.categoryList = res.data;
        }
      });
    },
    async getVideoList() {
      this.loading = true;
      await axiosGet("/api/video/list", this.videoSearch).then((res) => {
        if (res.code == 0) {
          this.videoList = res.data.records;
          this.total = res.data.total;
        }
      });
      this.loading = false;
    },
    searchList() {
      this.videoSearch.currentPage = 1;
      this.getVideoList();
    },
    handleSizeChange(val) {
      this.videoSearch.currentPage = 1;
      this.videoSearch.pageSize = val;
      this.getVideoList();
    },
    handleCurrentChange(val) {
      this.videoSearch.currentPage = val;
      this.getVideoList();
    },
    checkVideo(id) {
      this.$router.push({ path: "/TvVideoDetail", query: { id: id } });
    },
    deleteVideo(id) {
      this.$confirm("此操作将永久删除该视频, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        axiosPost("/api/video/delete", { id: id }, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "删除成功", type: "success" });
            this.getVideoList();
          }
        });
      });
    },
    playVideo(name, url) {
      this.videoUrl = url;
      this.videoName = name;
      this.dialogFormVisible = true;
    },
    handleClose() {
      this.videoUrl = "";
      this.videoName = "";
      this.dialogFormVisible = false;
    },
  },
  mounted() {
    this.getCategoryList();
    this.getVideoList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/TvVideoManager/index.vue